<div class="quick-links-container">
    <div class="flex-grid-thirds upper-row row m-0">
        <div class="col-md-2 col-sm-6 quick-link-tile" routerLink="/check-price-availability">
            <a class="quick-link">
                <i class="material-icons">done</i>
            </a>
            <span class="quick-link-text">{{ "landing.checckprice" | cxTranslate }}</span>
        </div>

        <div class="col-md-2 col-sm-6 quick-link-tile" routerLink="/quote-list">
            <a  class="quick-link">
                <i class="material-icons-outlined">grading</i>
            </a>
            <span class="quick-link-text">{{ "landing.reviewquote" | cxTranslate }}</span>
        </div>

        <div class="col-md-2 col-sm-6 quick-link-tile" routerLink="/order-history">
            <a  class="quick-link">
                <i class="material-icons-outlined">outbond</i>
            </a>
            <span class="quick-link-text">{{ "landing.checkordersttaus" | cxTranslate }}</span>
        </div>

        <div class="col-md-2 col-sm-6 quick-link-tile" (click)="goTobomLpn()">
            <a class="quick-link">
                <i class="material-icons">insert_link</i>
            </a>
            <span class="quick-link-text">{{ "landing.bomLpn" | cxTranslate }}</span>
        </div>

        <div class="col-md-2 col-sm-6 quick-link-tile" routerLink="/faq">
            <a class="quick-link">
                <i class="material-icons">note_add</i>
            </a>
            <span class="quick-link-text">{{ "landing.faq" | cxTranslate }}</span>
        </div>

        <div class="col-md-2 col-sm-6 quick-link-tile" (click)="goToRequestTraining()">
            <a class="quick-link">
                <i class="material-icons">local_library</i>
            </a>
            <span class="quick-link-text">{{ "landing.requestTraining" | cxTranslate }}</span>
        </div>
    </div>
</div>
